import styles from "./Dashboard.module.css";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/auth.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoiceDollar,faCakeCandles } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import billService from "../../services/bill.service";
import learnersServices from "../../services/learner.service";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

dayjs.extend(isBetween);

function Dashboard() {
  const [bills, setBills] = useState([]);
  const [birthDates, setBirthDates] = useState([]);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchBills = async () => {
      const bills = await billService.getBills();

      const billsUser =
        bills?.data.filter(
          (bill) => bill.user === user?.email && !bill.received
        ) || [];

      setBills(billsUser);
    };

    const fetchBirthDates = async () => {
      const learners = await learnersServices.getAllLearners();
      const today = dayjs();
      const fifteenDaysAgo = today.subtract(15, "day");

      const birthDates =
        learners.data.filter((learner) => {
          if (!learner.birthDate) {
            return false;
          }

          const birthDate = dayjs(learner.birthDate).year(today.year());

          return dayjs(birthDate).isBetween(fifteenDaysAgo, today);
        }) || [];

      setBirthDates(birthDates);
    };

    fetchBills();
    fetchBirthDates();
  }, [user]);

  return (
    <div className={styles["dashboard-container"]}>
      <ScreenHeader title="Dashboard" showBack={false} showMenu={true} />

      <div className={styles["dashboard-content"]}>
        {bills.length > 0 && (
          <section className={styles["dashboard-section"]}>
            <div className={styles["dashboard-card"]}>
              <h2 className={styles["dashboard-card-title"]}>
                <FontAwesomeIcon icon={faFileInvoiceDollar} className={styles["dashboard-icon"]} />
                Facturas Pendientes de Entrega
              </h2>
              <div className={styles["dashboard-list"]}>
                {bills.map((bill, index) => (
                  <div key={index} className={styles["dashboard-list-item"]}>
                    <span className={styles["dashboard-item-description"]}>
                      {bill.description}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {birthDates.length > 0 && (
          <section className={styles["dashboard-section"]}>
            <div className={styles["dashboard-card"]}>
              <h2 className={styles["dashboard-card-title"]}>
                <FontAwesomeIcon icon={faCakeCandles} className={styles["dashboard-icon"]} />
                Cumpleaños (últimos 15 días)
              </h2>
              <div className={styles["dashboard-list"]}>
                {birthDates
                  .sort((a, b) => {
                    const year = dayjs().year();
                    return (
                      dayjs(b.birthDate).year(year).valueOf() -
                      dayjs(a.birthDate).year(year).valueOf()
                    );
                  })
                  .map(({ name, birthDate }, index) => (
                    <div key={index} className={`${styles["dashboard-list-item"]} ${styles["birthday-item"]}`}>
                      <div className={styles["birthday-info"]}>
                        <span className={styles["birthday-name"]}>{name}</span>
                        <span className={styles["birthday-date"]}>
                          {`${dayjs(birthDate).date()}/${
                            dayjs(birthDate).month() + 1
                          }`}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        )}

        {bills.length === 0 && birthDates.length === 0 && (
          <div className={styles["dashboard-empty"]}>
            <p>No hay notificaciones pendientes</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
